import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  UpdateCancelationReasonActions as Actions,
  UpdateCancelationReasonRequestAction as RequestAction,
} from 'store/ducks/cancelationReasons';

export function* updateCancelationReasonRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.put, `cancelation-reasons/${id}`, putData);
    onSuccess && onSuccess();
    notify('success', 'Justificativa atualizada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
